import service from "@irati-tracking/tracker"

export const trackingOnlineGP = {
  navigate: () => service.trackOnlineGPEvent("ogp_from_menu"),
  view: () => service.trackOnlineGPEvent("ogp_view"),
  expand: () => service.trackOnlineGPEvent("ogp_data_expand"),
  clickFAQ: () => service.trackOnlineGPEvent("ogp_click_faq"),
  clickCTA: () => service.trackOnlineGPEvent("ogp_click_cta")
}
